module.exports = __webpack_public_path__ + "img/care_none.3fc60f7e.png";